import { Icon, UserOutlineIcon } from '@fountain/ripple/icon';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';

import globalMessages from 'shared/global/messages';

import useStyles from './styles';

function RecipientsCard({ applicantsCount, title, intl }) {
  const classes = useStyles();

  return (
    <Grid className={classes.recipientsCard}>
      <Typography variant="h4">{title}</Typography>
      <Grid
        container
        alignItems="center"
        className={classes.applicantsCountContainer}
      >
        <Icon
          icon={UserOutlineIcon}
          size="xs"
          color="neutral-400"
          className={classes.applicantIcon}
        />
        <Typography variant="overline">
          {intl.formatMessage(globalMessages.recipientsCount, {
            count: applicantsCount,
          })}
        </Typography>
      </Grid>
    </Grid>
  );
}

RecipientsCard.propTypes = {
  intl: PropTypes.object.isRequired,
  applicantsCount: PropTypes.number,
  title: PropTypes.string.isRequired,
};

export default RecipientsCard;
